import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { ReclamationActionDetailCodes } from 'constants.js';

import NumberFormatQuantite from 'components/Shared/NumberFormatQuantite';

const styles = theme => ({
    formControl: {
        width: '100%',
        marginBottom: '20px'
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});

class ControlePoidsDialogContent extends React.Component {

    state = {
        commentaire: "",
        controleOk: null,
        poidsReel: 0,
        poidsTheorique: 0
    };

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (newState.controleOk === null) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Booleen,
                libelle: 'Le résultat est-il conforme ?',
                position: 0,
                valeurBool: newState.controleOk === '1'
            }]
        };

        if (newState.poidsReel) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Poids,
                type: ReclamationActionDetailType.Entier,
                libelle: 'Poids réel (en g)',
                position: actionData.details.length,
                valeurInteger: parseInt(newState.poidsReel, 10)
            });
        }

        if (newState.poidsTheorique) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Poids,
                type: ReclamationActionDetailType.Entier,
                libelle: 'Poids théorique (en g)',
                position: actionData.details.length,
                valeurInteger: parseInt(newState.poidsTheorique, 10)
            });
        }

        if (newState.commentaire) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Commentaire',
                position: actionData.details.length,
                valeurString: newState.commentaire
            });
        }


        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }




    handleChangePoidsReel = (event) => {

        let newState =
        {
            ...this.state,
            poidsReel: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    handleChangePoidsTheorique = (event) => {

        let newState =
        {
            ...this.state,
            poidsTheorique: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { commentaire, controleOk, poidsReel, poidsTheorique } = this.state;

        return (
            <DialogContent>
                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Le résultat est-il conforme ?</FormLabel>
                    <RadioGroup
                        required
                        aria-label="controle"
                        name="controleOk"
                        className={classes.group}
                        value={controleOk}
                        onChange={this.handleChange}
                    >
                        <FormControlLabel value="1" control={<Radio />} label="Oui" />
                        <FormControlLabel value="0" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

                {controleOk === '0' && (
                    <React.Fragment>
                        <TextField
                            className={classes.formControl}
                            id="poidsReel"
                            name="poidsReel"
                            label="Poids réel (en g)"
                            placeholder="Poids réel (en g)"
                            value={poidsReel}
                            onChange={this.handleChangePoidsReel}
                            InputProps={{
                                inputComponent: NumberFormatQuantite
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                        <TextField
                            className={classes.formControl}
                            id="poidsTheorique"
                            name="poidsTheorique"
                            label="Poids théorique (en g)"
                            placeholder="Poids théorique (en g)"
                            value={poidsTheorique}
                            onChange={this.handleChangePoidsTheorique}
                            InputProps={{
                                inputComponent: NumberFormatQuantite
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />

                    </React.Fragment>
                )}

                <TextField className={classes.formControl}
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={this.handleChange}
                />

            </DialogContent>
        );
    }
}

ControlePoidsDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(ControlePoidsDialogContent);